var React = require('react');

function Screen (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"_01_align_center","data-name":"01 align center"},React.createElement("path",{"d":"M24,19V6a3,3,0,0,0-3-3H3A3,3,0,0,0,0,6V19H11v1H7v2H17V20H13V19ZM2,6A1,1,0,0,1,3,5H21a1,1,0,0,1,1,1V17H2Z"})));
}

Screen.defaultProps = {"viewBox":"0 0 24 24","fill":"#ffffff"};

module.exports = Screen;

Screen.default = Screen;
